import Seo from '../components/Seo';

export default function PoliticaCookies() {
  const reopenBanner = () => {
    try { localStorage.removeItem('cabrero_cookie_consent'); } catch (_) { /* ignore */ }
    try {
      if (typeof window !== 'undefined' && window.posthog?.clear_opt_in_out_capturing) {
        window.posthog.clear_opt_in_out_capturing();
      }
    } catch (_) { /* ignore */ }
    window.location.reload();
  };

  return (
    <>
      <Seo
        title="Política de Cookies"
        description="Política de Cookies de barcabrero.com conforme al art. 22.2 de la Ley 34/2002 (LSSI-CE). Tipos de cookies, finalidades y cómo gestionar tu consentimiento."
        path="/politica-cookies"
      />
      <article className="sec legal-page" data-testid="politica-cookies">
        <p className="eyebrow rv">Cookies</p>
        <h1 className="D D-lg rv" style={{ marginBottom: '1.5rem' }}>Política de Cookies</h1>
        <p className="lead rv" style={{ marginBottom: '2.5rem' }}>
          La presente Política informa sobre el uso de cookies en <em>barcabrero.com</em>, conforme al artículo 22.2 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y de Comercio Electrónico (LSSI-CE) y la Guía de Cookies de la Agencia Española de Protección de Datos.
        </p>

        <div className="legal-body rv">
          <h2>1. ¿Qué son las cookies?</h2>
          <p>
            Las cookies son pequeños archivos de texto que un sitio web instala en el navegador o dispositivo del usuario para almacenar y recuperar información sobre su navegación. Pueden ser propias (instaladas por el responsable del sitio) o de terceros (instaladas por otros prestadores).
          </p>

          <h2>2. Cookies utilizadas en este sitio</h2>

          <h3>2.1. Cookies técnicas (necesarias) — exentas de consentimiento</h3>
          <p>Son imprescindibles para el funcionamiento básico del sitio y no recogen información con fines publicitarios o analíticos.</p>
          <table className="legal-table">
            <thead><tr><th>Cookie</th><th>Tipo</th><th>Finalidad</th><th>Duración</th></tr></thead>
            <tbody>
              <tr>
                <td><code>cabrero_cookie_consent</code></td>
                <td>Propia · Técnica</td>
                <td>Recordar la elección del usuario respecto al banner de cookies.</td>
                <td>12 meses</td>
              </tr>
            </tbody>
          </table>

          <h3>2.2. Cookies analíticas — requieren consentimiento</h3>
          <p>Permiten medir y analizar el uso del sitio para mejorar la experiencia. Solo se activan si el usuario acepta expresamente.</p>
          <table className="legal-table">
            <thead><tr><th>Cookie</th><th>Tipo</th><th>Finalidad</th><th>Duración</th></tr></thead>
            <tbody>
              <tr>
                <td><code>ph_*</code> (PostHog)</td>
                <td>Tercero · Analítica</td>
                <td>Medir páginas visitadas, sesiones, dispositivos y comportamiento general en el sitio. Datos agregados, no identificativos.</td>
                <td>12 meses</td>
              </tr>
            </tbody>
          </table>
          <p>
            <strong>Tercero:</strong> PostHog Inc. (Estados Unidos) — Transferencia internacional amparada por Cláusulas Contractuales Tipo. Más información en <a href="https://posthog.com/privacy" target="_blank" rel="noopener noreferrer">posthog.com/privacy</a>.
          </p>

          <h2>3. Cómo gestionar tu consentimiento</h2>
          <p>
            Al acceder por primera vez al sitio, se muestra un banner donde puedes <strong>Aceptar</strong> o <strong>Rechazar</strong> las cookies analíticas. Las técnicas se aplican siempre, ya que son necesarias para el funcionamiento.
          </p>
          <p>
            Puedes <strong>revocar tu consentimiento en cualquier momento</strong>, lo que mostrará nuevamente el banner para que actualices tu decisión:
          </p>
          <p style={{ marginTop: '1rem' }}>
            <button type="button" className="btn btn-g" onClick={reopenBanner} data-testid="reopen-cookie-banner">
              Cambiar mis preferencias de cookies
            </button>
          </p>

          <h2>4. Configuración del navegador</h2>
          <p>
            Adicionalmente, puedes bloquear o eliminar cookies desde tu navegador. Cada navegador tiene una configuración distinta:
          </p>
          <ul className="legal-list">
            <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener noreferrer">Google Chrome</a></li>
            <li><a href="https://support.mozilla.org/es/kb/proteccion-mejorada-contra-rastreo-firefox-escrito" target="_blank" rel="noopener noreferrer">Mozilla Firefox</a></li>
            <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener noreferrer">Apple Safari</a></li>
            <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noopener noreferrer">Microsoft Edge</a></li>
          </ul>
          <p>
            Ten en cuenta que la desactivación total de cookies puede impedir el funcionamiento correcto de algunas partes del sitio.
          </p>

          <h2>5. Más información</h2>
          <p>
            Para más detalle sobre el tratamiento de tus datos, consulta nuestra <a href="/politica-privacidad">Política de Privacidad</a>. Si tienes cualquier consulta, escríbenos a <a href="mailto:info@barcabrero.com">info@barcabrero.com</a>.
          </p>

          <p className="legal-updated">Última actualización: 6 de febrero de 2026.</p>
        </div>
      </article>
    </>
  );
}
